/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highcontrast_Imagery_Works_BeInputs */

const en_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-contrast imagery works best for the luxury themes. Ensure the focal point is not obscured by text.`)
};

const es_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las imágenes de alto contraste funcionan mejor para los temas de lujo. Asegúrate de que el punto focal no esté oscurecido por el texto.`)
};

const fr_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les images à fort contraste fonctionnent le mieux pour les thèmes de luxe. Assurez-vous que le point focal n'est pas masqué par le texte.`)
};

const de_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder mit hohem Kontrast eignen sich am besten für Luxus-Themen. Stelle sicher, dass der Fokuspunkt nicht durch Text verdeckt wird.`)
};

const ja_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラグジュアリーテーマには高コントラストの画像が最適です。テキストによって焦点が隠れないようにしてください。`)
};

const zh_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高对比度图像最适合奢华主题。请确保视觉焦点不被文字遮挡。`)
};

const ar_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصور عالية التباين تعمل بشكل أفضل للمظاهر الفاخرة. تأكد من أن النقطة البؤرية ليست محجوبة بالنص.`)
};

const id_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citra kontras tinggi bekerja paling baik untuk tema mewah. Pastikan titik fokus tidak terhalang oleh teks.`)
};

const it_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le immagini ad alto contrasto funzionano meglio per i temi di lusso. Assicurati che il punto focale non sia oscurato dal testo.`)
};

const ru_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Высококонтрастные изображения лучше всего подходят для премиальных тем. Убедитесь, что текст не перекрывает фокус изображения.`)
};

const pt_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagens de alto contraste funcionam melhor para temas de luxo. Certifique-se de que o ponto focal não esteja obscurecido pelo texto.`)
};

const ko_highcontrast_imagery_works_be = /** @type {(inputs: Highcontrast_Imagery_Works_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고대비 이미지가 럭셔리 테마에 가장 적합합니다. 텍스트가 포커스 영역을 가리지 않도록 주의하세요.`)
};

/**
* | output |
* | --- |
* | "High-contrast imagery works best for the luxury themes. Ensure the focal point is not obscured by text." |
*
* @param {Highcontrast_Imagery_Works_BeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const highcontrast_imagery_works_be = /** @type {((inputs?: Highcontrast_Imagery_Works_BeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highcontrast_Imagery_Works_BeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_highcontrast_imagery_works_be(inputs)
	if (locale === "es") return es_highcontrast_imagery_works_be(inputs)
	if (locale === "fr") return fr_highcontrast_imagery_works_be(inputs)
	if (locale === "de") return de_highcontrast_imagery_works_be(inputs)
	if (locale === "ja") return ja_highcontrast_imagery_works_be(inputs)
	if (locale === "zh") return zh_highcontrast_imagery_works_be(inputs)
	if (locale === "ar") return ar_highcontrast_imagery_works_be(inputs)
	if (locale === "id") return id_highcontrast_imagery_works_be(inputs)
	if (locale === "it") return it_highcontrast_imagery_works_be(inputs)
	if (locale === "ru") return ru_highcontrast_imagery_works_be(inputs)
	if (locale === "pt") return pt_highcontrast_imagery_works_be(inputs)
	return ko_highcontrast_imagery_works_be(inputs)
});